import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquarePlus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSquarePlus"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM8.00005 10.9999L7.99998 12.9999L11 13.0001L11 16L13 16L13 13.0001L16 13.0003L16.0001 11.0003L13 11.0001L13 8.00022L11 8.00021L11 11.0001L8.00005 10.9999Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquarePlus;
